// src/pages/QysDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function QysDetail() {
  const { qysId } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const cargarQyS = async () => {
      try {
        setLoading(true);
        setError("");

        const ref = doc(db, "qys", qysId);
        const snap = await getDoc(ref);

        if (!snap.exists()) {
          setError("No se encontró la queja/sugerencia.");
          return;
        }

        const data = snap.data();
        setItem({
          id: snap.id,
          ...data,
          fechaCreacion: data.fechaCreacion?.toDate?.() || null,
        });
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    cargarQyS();
  }, [qysId]);

  if (loading) return <p>Cargando detalle...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!item) return <p>No se encontró el registro.</p>;

  const handleVerUsuario = () => {
    if (!item.userId) return;
    navigate(`/users/${item.userId}`);
  };

  return (
    <div>
      <Link to="/qys">← Volver a lista de quejas</Link>

      <h1 style={{ marginTop: 16 }}>Detalle de queja / sugerencia</h1>

      <p>
        <strong>ID:</strong> {item.id}
      </p>
      <p>
        <strong>Usuario ID:</strong> {item.userId || "(sin userId)"}
      </p>
      <p>
        <strong>Fecha creación:</strong>{" "}
        {item.fechaCreacion
          ? item.fechaCreacion.toLocaleString()
          : "-"}
      </p>

      <div style={{ margin: "12px 0" }}>
        <button
          onClick={handleVerUsuario}
          disabled={!item.userId}
        >
          Ver usuario
        </button>
      </div>

      <hr style={{ margin: "16px 0" }} />

      <div style={{ marginBottom: 16 }}>
        <p>
          <strong>Título:</strong>
        </p>
        <p>{item.titulo || "(sin título)"}</p>
      </div>

      <div>
        <p>
          <strong>Mensaje:</strong>
        </p>
        <pre
          style={{
            background: "#f7f7f7",
            padding: 12,
            borderRadius: 6,
            whiteSpace: "pre-wrap",
          }}
        >
          {item.mensaje || "(sin mensaje)"}
        </pre>
      </div>
    </div>
  );
}
